<template>
  <div class="act-root">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
        <template #left>
          <!-- 这是黑色返回箭头 -->
          <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <template v-if="activityStatus === 'on'">
      <div class="act-top" :style="{ marginTop: `-${barHeight + 46}px` }">
        <div class="top-block">
          <div :style="{ height: `${barHeight + 46}px` }"></div>
          <p class="act-tit1">{{ $t('lang.BlackFriday.k001') }}</p>
          <p class="act-tit2">{{ $t('lang.BlackFriday.k002') }}</p>

          <!-- prettier-ignore -->
          <div class="rec-date-block">
            <div class="clock"></div>
            <div class="dead-line">
              <div class="num time">{{ countdownResult.days }}</div><div class="union">{{ $t('lang.ActCommon.k049') }}</div>
              <div class="num step"> : </div>
              <div class="num time">{{ countdownResult.hours }}</div><div class="union">{{ $t('lang.ActCommon.k060') }}</div>
              <div class="num step"> : </div>
              <div class="num time">{{ countdownResult.minutes }}</div><div class="union">{{ $t('lang.ActCommon.k061') }}</div>
              <div class="num step"> : </div>
              <div class="num time">{{ countdownResult.seconds }}</div><div class="union">{{ $t('lang.ActCommon.k062') }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="act-con act-con-coins">
        <div class="rec-fir-deliver">
          <div class="deliver-l">
            <div></div>
          </div>
          <div v-if="baseInfo && baseInfo.activityGroup === 'A'" class="rec-fir-deliver-text">{{ $t('lang.BlackFriday.k003') }}</div>
          <div v-if="baseInfo && baseInfo.activityGroup === 'B'" class="rec-fir-deliver-text">{{ $t('lang.BlackFriday.k004') }}</div>
          <div class="deliver-r">
            <div></div>
          </div>
        </div>
        <div class="rec-coins">
          <div class="rec-coins-left">
            <div class="rec-coins-tit">{{ $t('lang.ActCommon.k050') }}</div>
            <!-- prettier-ignore -->
            <div v-if="baseInfo" class="rec-coins-num">
              <img :src="getMatchImg('coin')" />{{ baseInfo.originAmount }}
            </div>
          </div>
          <div class="rec-coins-center">
            <div class="up-img"></div>
          </div>
          <div class="rec-coins-right">
            <div class="rec-coins-tit">{{ $t('lang.ActCommon.k051') }}</div>
            <!-- prettier-ignore -->
            <div v-if="baseInfo" class="rec-coins-num">
              <img :src="getMatchImg('coins')" />{{ baseInfo.amount }}
            </div>
          </div>
          <!-- prettier-ignore -->
          <div v-if="baseInfo" class="rec-coins-discount">
            <i class="plus">+</i>{{ baseInfo.discountDesc }}
          </div>
        </div>

        <template v-if="baseInfo">
          <div v-if="baseInfo.ifClickable === true" class="rec-coins-btn" @click="handleClaim">
            <img :src="baseInfo.currencyIcon | imgPath" />
            <div>
              <i>{{ baseInfo.currency }}</i>
              <span>{{ handleDiv100(baseInfo.price) }}</span>
            </div>
          </div>

          <div v-else class="rec-coins-btn disable">
            <img :src="baseInfo.currencyIcon | imgPath" />
            <div>
              <i>{{ baseInfo.currency }}</i>
              <span>{{ handleDiv100(baseInfo.price) }}</span>
            </div>
          </div>
        </template>

        <p class="rec-coins-tips">{{ $t('lang.BlackFriday.k005') }}</p>
      </div>

      <div class="act-con act-con-pan">
        <div class="rec-fir-deliver">
          <div class="deliver-l">
            <div></div>
          </div>
          <div class="rec-fir-deliver-text">{{ $t('lang.BlackFriday.k014') }}</div>
          <div class="deliver-r">
            <div></div>
          </div>
        </div>

        <div class="wheel-pan-block">
          <div class="wheel-pan">
            <div class="outher">
              <div v-if="baseInfo" ref="wapper" class="wapper">
                <div class="part1">
                  <div v-if="panData && panData[0]" class="item one" :class="{ got: gotDrawnId === panData[0].id }">
                    <div class="text">
                      <!-- props -->
                      <template v-if="panData[0].type === 'props'">
                        <!-- prettier-ignore -->
                        <div class="pan-txt-item">
                          <img :src="getMatchImg('video-pass')" />x{{ panData[0].reward[2] }}
                        </div>
                        <!-- prettier-ignore -->
                        <div class="pan-txt-item">
                          <img :src="getMatchImg('super-chat-pass')" />x{{ panData[0].reward[15] }}
                        </div>
                      </template>
                      <!-- coins -->
                      <template v-if="panData[0].type === 'coins'">
                        <div class="pan-num-item">
                          <div class="discount">{{ panData[0].reward[0] }}</div>
                          <img :src="getMatchImg('coins')" />
                        </div>
                      </template>
                    </div>
                  </div>
                  <div v-if="panData && panData[1]" class="item two" :class="{ got: gotDrawnId === panData[1].id }">
                    <div class="text">
                      <!-- props -->
                      <template v-if="panData[1].type === 'props'">
                        <!-- prettier-ignore -->
                        <div class="pan-txt-item">
                          <img :src="getMatchImg('video-pass')" />x{{ panData[1].reward[2] }}
                        </div>
                        <!-- prettier-ignore -->
                        <div class="pan-txt-item">
                          <img :src="getMatchImg('super-chat-pass')" />x{{ panData[1].reward[15] }}
                        </div>
                      </template>
                      <!-- coins -->
                      <template v-if="panData[1].type === 'coins'">
                        <div class="pan-num-item">
                          <div class="discount">{{ panData[1].reward[0] }}</div>
                          <img :src="getMatchImg('coins')" />
                        </div>
                      </template>
                    </div>
                  </div>
                  <div v-if="panData && panData[2]" class="item three" :class="{ got: gotDrawnId === panData[2].id }">
                    <div class="text">
                      <!-- props -->
                      <template v-if="panData[2].type === 'props'">
                        <!-- prettier-ignore -->
                        <div class="pan-txt-item">
                          <img :src="getMatchImg('video-pass')" />x{{ panData[2].reward[2] }}
                        </div>
                        <!-- prettier-ignore -->
                        <div class="pan-txt-item">
                          <img :src="getMatchImg('super-chat-pass')" />x{{ panData[2].reward[15] }}
                        </div>
                      </template>
                      <!-- coins -->
                      <template v-if="panData[2].type === 'coins'">
                        <div class="pan-num-item">
                          <div class="discount">{{ panData[2].reward[0] }}</div>
                          <img :src="getMatchImg('coins')" />
                        </div>
                      </template>
                    </div>
                  </div>
                  <div v-if="panData && panData[3]" class="item four" :class="{ got: gotDrawnId === panData[3].id }">
                    <div class="text">
                      <!-- props -->
                      <template v-if="panData[3].type === 'props'">
                        <!-- prettier-ignore -->
                        <div class="pan-txt-item">
                          <img :src="getMatchImg('video-pass')" />x{{ panData[3].reward[2] }}
                        </div>
                        <!-- prettier-ignore -->
                        <div class="pan-txt-item">
                          <img :src="getMatchImg('super-chat-pass')" />x{{ panData[3].reward[15] }}
                        </div>
                      </template>
                      <!-- coins -->
                      <template v-if="panData[3].type === 'coins'">
                        <div class="pan-num-item">
                          <div class="discount">{{ panData[3].reward[0] }}</div>
                          <img :src="getMatchImg('coins')" />
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
                <div class="part2">
                  <div v-if="panData && panData[4]" class="item five" :class="{ got: gotDrawnId === panData[4].id }">
                    <div class="text">
                      <!-- props -->
                      <template v-if="panData[4].type === 'props'">
                        <!-- prettier-ignore -->
                        <div class="pan-txt-item">
                          <img :src="getMatchImg('video-pass')" />x{{ panData[4].reward[2] }}
                        </div>
                        <!-- prettier-ignore -->
                        <div class="pan-txt-item">
                          <img :src="getMatchImg('super-chat-pass')" />x{{ panData[4].reward[15] }}
                        </div>
                      </template>
                      <!-- coins -->
                      <template v-if="panData[4].type === 'coins'">
                        <div class="pan-num-item">
                          <div class="discount">{{ panData[4].reward[0] }}</div>
                          <img :src="getMatchImg('coins')" />
                        </div>
                      </template>
                    </div>
                  </div>
                  <div v-if="panData && panData[5]" class="item six" :class="{ got: gotDrawnId === panData[5].id }">
                    <div class="text">
                      <!-- props -->
                      <template v-if="panData[5].type === 'props'">
                        <!-- prettier-ignore -->
                        <div class="pan-txt-item">
                          <img :src="getMatchImg('video-pass')" />x{{ panData[5].reward[2] }}
                        </div>
                        <!-- prettier-ignore -->
                        <div class="pan-txt-item">
                          <img :src="getMatchImg('super-chat-pass')" />x{{ panData[5].reward[15] }}
                        </div>
                      </template>
                      <!-- coins -->
                      <template v-if="panData[5].type === 'coins'">
                        <div class="pan-num-item">
                          <div class="discount">{{ panData[5].reward[0] }}</div>
                          <img :src="getMatchImg('coins')" />
                        </div>
                      </template>
                    </div>
                  </div>
                  <div v-if="panData && panData[6]" class="item seven" :class="{ got: gotDrawnId === panData[6].id }">
                    <div class="text">
                      <!-- props -->
                      <template v-if="panData[6].type === 'props'">
                        <!-- prettier-ignore -->
                        <div class="pan-txt-item">
                          <img :src="getMatchImg('video-pass')" />x{{ panData[6].reward[2] }}
                        </div>
                        <!-- prettier-ignore -->
                        <div class="pan-txt-item">
                          <img :src="getMatchImg('super-chat-pass')" />x{{ panData[6].reward[15] }}
                        </div>
                      </template>
                      <!-- coins -->
                      <template v-if="panData[6].type === 'coins'">
                        <div class="pan-num-item">
                          <div class="discount">{{ panData[6].reward[0] }}</div>
                          <img :src="getMatchImg('coins')" />
                        </div>
                      </template>
                    </div>
                  </div>
                  <div v-if="panData && panData[7]" class="item eight" :class="{ got: gotDrawnId === panData[7].id }">
                    <div class="text">
                      <!-- props -->
                      <template v-if="panData[7].type === 'props'">
                        <!-- prettier-ignore -->
                        <div class="pan-txt-item">
                          <img :src="getMatchImg('video-pass')" />x{{ panData[7].reward[2] }}
                        </div>
                        <!-- prettier-ignore -->
                        <div class="pan-txt-item">
                          <img :src="getMatchImg('super-chat-pass')" />x{{ panData[7].reward[15] }}
                        </div>
                      </template>
                      <!-- coins -->
                      <template v-if="panData[7].type === 'coins'">
                        <div class="pan-num-item">
                          <div class="discount">{{ panData[7].reward[0] }}</div>
                          <img :src="getMatchImg('coins')" />
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wheel-pointer"></div>
          </div>
          <div class="wheel-base"></div>
          <div class="wheel-tips">
            {{ $t('lang.BlackFriday.k006') }}
            <i>{{ spinCount }}</i>
          </div>
        </div>

        <p class="rec-coins-tips in-pan">{{ $t('lang.BlackFriday.k007') }}</p>

        <!-- 转盘按钮-可用 -->
        <div v-if="spinCount > 0" class="rec-coins-btn" @click="handleWheelPan">
          <div>{{ $t('lang.BlackFriday.k008') }}</div>
        </div>
        <!-- 转盘按钮-置灰 -->
        <div v-else class="rec-coins-btn disable">
          <div>{{ $t('lang.BlackFriday.k008') }}</div>
        </div>
      </div>

      <div class="act-tips">
        <div class="act-tips-tit">{{ $t('lang.BlackFriday.k009') }}</div>
        <div class="act-tips-con">
          1.&nbsp;
          <p>{{ $t('lang.BlackFriday.k010') }}</p>
        </div>
        <div class="act-tips-con">
          2.&nbsp;
          <p>{{ $t('lang.BlackFriday.k011') }}</p>
        </div>
      </div>

      <div v-if="showDia" class="mask">
        <div class="dialog">
          <div class="dia-tit">
            <p>{{ $t('lang.BlackFriday.k012') }}</p>
            <p>{{ $t('lang.BlackFriday.k013') }}</p>
          </div>
          <div v-if="gotObj" class="dia-con">
            <template v-if="gotObj.type === 'props'">
              <div class="gift-item">
                <div class="gift-icon">
                  <img :src="getMatchImg('video-pass')" />
                </div>
                <div class="gift-num" v-if="gotObj.reward">x{{ gotObj.reward[2] }}</div>
              </div>
              <div class="gift-gap"></div>
              <div class="gift-item">
                <div class="gift-icon">
                  <img :src="getMatchImg('super-chat-pass')" />
                </div>
                <div class="gift-num" v-if="gotObj.reward">x{{ gotObj.reward[15] }}</div>
              </div>
            </template>
            <template v-if="gotObj.type === 'coins'">
              <div class="gift-item">
                <div class="gift-icon">
                  <img :src="getMatchImg('coins')" />
                </div>
                <div class="gift-num" v-if="gotObj.reward">x{{ gotObj.reward[0] }}</div>
              </div>
            </template>
          </div>
          <div class="dia-btn" @click="handleGotOk">{{ $t('lang.ActCommon.k100') }}</div>
        </div>
      </div>
    </template>

    <template v-if="activityStatus === 'off'">
      <ActEnd />
    </template>
  </div>
</template>

<script>
import { apiWheelActCfg, apiWheelActDraw } from './apidir/api.js'

import countDown from '@/mixin/count-down.js'

import ActEnd from '@/components/ActivityEnd/index.vue'

export default {
  mixins: [countDown],
  components: { ActEnd },
  data() {
    return {
      appInfo: null,
      activityType: '19',
      activityStatus: 'on',
      // 转盘数据
      isWheeling: false,
      panData: [
        // {
        //   id: 7
        // }
      ],
      spinCount: 0,
      gotDrawnId: null,
      gotObj: null,
      // 页面数据
      baseInfo: null,
      // 弹框
      showDia: false
    }
  },
  methods: {
    // 转盘方法
    handleWheelPan() {
      if (this.spinCount > 0) {
        apiWheelActDraw(this.activityType).then((resData) => {
          // const resData = {
          //   lastDrawId: 51
          // }
          if (resData && !resData.error) {
            const willGotId = resData.lastDrawId
            const originIndex = this.panData.findIndex((item) => item.id === willGotId)
            if (originIndex > -1) {
              this.gotObj = this.panData[originIndex]
              this.spinCount = resData.drawCount

              const cbFn = () => {
                this.gotDrawnId = willGotId
                this.showDia = true
              }
              switch (originIndex) {
                case 0:
                  this.doWheelPan(-22.5, cbFn)
                  break
                case 1:
                  this.doWheelPan(-67.5, cbFn)
                  break
                case 2:
                  this.doWheelPan(-112.5, cbFn)
                  break
                case 3:
                  this.doWheelPan(-157.5, cbFn)
                  break
                case 4:
                  this.doWheelPan(157.5, cbFn)
                  break
                case 5:
                  this.doWheelPan(112.5, cbFn)
                  break
                case 6:
                  this.doWheelPan(67.5, cbFn)
                case 7:
                  this.doWheelPan(22.5, cbFn)
                  break
              }
              // 数数上报点击wheel
              // try {
              //   window.ta && window.ta.track('h5_page_track', { Action: 'Click', APosition: 'button', AValue: 'repurchase-9.99-click-wheel' })
              // } catch (err) {
              //   console.log('try catch', err)
              // }
            }
          }
        })
      }
    },
    doWheelPan(angle, fn) {
      this.isWheeling = true

      let begin = 0
      const basic = 1800

      const timer = setInterval(() => {
        if (begin > basic + angle) {
          this.isWheeling = false
          clearInterval(timer)
          fn && fn()
        }
        this.$refs.wapper.style.transform = 'rotate(' + begin + 'deg)'
        begin += Math.ceil(basic + angle - begin) * 0.1
      }, 70)
    },
    handleGotOk() {
      this.showDia = false
      this.gotDrawnId = null
      this.$refs.wapper.style.transform = 'rotate(' + 0 + 'deg)'
    },
    // 业务方法
    handleClaim() {
      if (!this.baseInfo) {
        return
      }
      // 支付基础参数
      const payQuery = {
        scene: 'activity',
        activityType: this.baseInfo.activityType,
        gid: this.baseInfo.gid,
        productId: this.baseInfo.productId,
        amount: this.baseInfo.amount,
        backType: 'previous'
      }

      // price currency参数控制 原生支付的显示
      // 下面这些版本之后，payGoogleFromWeb 才支持服务端需要回传的avtivityType
      const appChannel = this.getChannel()
      if (appChannel === 'vvg') {
        const appVerionsLimit = this.compareVersion(this.appInfo.version, '4.2.1')
        if (appVerionsLimit > 0) {
          payQuery.useWebPay = '1'
          payQuery.price = this.handleDiv100(this.baseInfo.price)
          payQuery.currency = this.baseInfo.currency
        }
      }
      if (appChannel === 'jcg') {
        const appVerionsLimit = this.compareVersion(this.appInfo.version, '2.3.0')
        if (appVerionsLimit > 0) {
          payQuery.useWebPay = '1'
          payQuery.price = this.handleDiv100(this.baseInfo.price)
          payQuery.currency = this.baseInfo.currency
        }
      }
      if (appChannel === 'eca') {
        const appVerionsLimit = this.compareVersion(this.appInfo.version, '1.2.1')
        if (appVerionsLimit > 0) {
          payQuery.useWebPay = '1'
          payQuery.price = this.handleDiv100(this.baseInfo.price)
          payQuery.currency = this.baseInfo.currency
        }
      }
      if (appChannel === 'ecg') {
        const appVerionsLimit = this.compareVersion(this.appInfo.version, '1.3.0')
        if (appVerionsLimit > 0) {
          payQuery.useWebPay = '1'
          payQuery.price = this.handleDiv100(this.baseInfo.price)
          payQuery.currency = this.baseInfo.currency
        }
      }

      if (appChannel === 'eca' || appChannel === 'ecg') {
        this.$router.push({
          path: '/echo-pay',
          query: payQuery
        })
        return
      }

      this.$router.push({
        path: '/pay',
        query: payQuery
      })
    },
    // 获得页面数据
    initData() {
      apiWheelActCfg(this.activityType).then((resData) => {
        if (Object.prototype.toString.call(resData) === '[object Object]' && Object.keys(resData).length && !resData.error) {
          this.activityStatus = 'on'
          this.baseInfo = resData

          // 转盘数据
          this.spinCount = resData.drawCount || 0
          if (resData.wheelConfig && resData.wheelConfig && resData.wheelConfig.length) {
            this.panData = resData.wheelConfig.map((item) => {
              let type = null

              if (item.reward) {
                const propTypes = Object.keys(item.reward)
                if (propTypes && propTypes.length) {
                  if (propTypes.length === 1 && propTypes[0] === '0') {
                    type = 'coins'
                  }
                  if (propTypes.length === 2 && propTypes.includes('2') && propTypes.includes('15')) {
                    type = 'props'
                  }
                }
              }

              return {
                id: item.id,
                type: type,
                reward: item.reward
              }
            })
          }

          // 倒计时
          try {
            this.initCountDown(resData.expireTimeMills, true, true)
          } catch (err) {
            console.log('try catch err:', err)
          }
        }
        // 活动结束
        else {
          this.activityStatus = 'off'
        }
      })
    },
    refresh() {
      this.initData()
    }
  },
  created() {
    this.appInfo = this.$client.getAppInfo() || { version: '' }
    this.initData()

    window.refresh = this.refresh

    // try {
    //   window.ta && window.ta.track('h5_page_track', { Action: 'Click', APosition: 'entrance', AValue: 'repurchase-9.99' })
    // } catch (err) {
    //   console.log('try catch', err)
    // }
  }
}
</script>

<style lang="less" scoped>
.act-root {
  width: 375px;
  margin: auto;
  min-height: 100vh;
  padding-bottom: 90px;
  background: linear-gradient(180deg, #292929 0%, #171614 100%);

  .custom-nav-block {
    background-color: transparent;
  }

  .act-top {
    position: relative;

    .top-block {
      width: 375px;
      height: 350px;
      background: url(./images/bf-top-bg.png) top left / 100% 100% no-repeat;
      .act-tit1 {
        margin-top: 14px;
        text-align: center;
        font-family: 'TikTokSans-Regular';
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;

        background: linear-gradient(186deg, #ffe2b5 28.49%, #ebbe5c 75.72%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }

      .act-tit2 {
        margin-top: 4px;
        text-align: center;
        font-family: 'TikTokSans-Regular';
        font-size: 32px;
        font-weight: 900;
        line-height: 36px;

        background: linear-gradient(186deg, #ffe2b5 28.49%, #ebbe5c 75.72%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }

    .rec-date-block {
      width: 299px;
      height: 47px;
      margin: 20px auto 0;
      font-size: 0;

      border-top: 1px solid rgba(255, 255, 255, 0);
      border-bottom: 1px solid rgba(255, 255, 255, 0);
      background: linear-gradient(183deg, rgba(255, 255, 255, 0.2) 2.45%, rgba(255, 255, 255, 0.1) 97.53%);
      backdrop-filter: blur(30px);

      display: flex;
      align-items: center;
      justify-content: center;

      .clock {
        width: 21px;
        height: 24px;
        background: url(./images/bf-clock.png) center center / 100% auto no-repeat;
        margin: 0 4px;
      }

      .dead-line {
        display: flex;
        align-items: flex-end;
        .num {
          color: #f6e7c8;
          text-align: center;
          font-family: 'TikTokSans-Regular';
          font-size: 24px;
          font-weight: 600;
          line-height: 28px;
        }

        .union {
          color: #f6e7c8;
          font-family: 'TikTokSans-Regular';
          font-size: 16px;
          font-weight: 600;
          line-height: 20px;
        }
        .step {
          margin: 0 3px;
        }
        .time {
          min-width: 31px;
        }
      }
    }
  }

  .act-con {
    width: 343px;
    margin: auto;
    padding: 20px 0;

    .rec-fir-deliver {
      width: 100%;
      color: #f2d185;
      text-align: center;
      font-family: 'TikTokSans-Regular';
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;

      display: flex;
      align-items: center;
      justify-content: center;
      .deliver-l,
      .deliver-r {
        flex: 1;
        position: relative;
        opacity: 0.5;
      }
      .deliver-l {
        div {
          width: 100%;
          height: 12px;
          background: url(./images/bf-splite.png) top left / 100% 100% no-repeat;
        }
      }
      .deliver-r {
        div {
          width: 100%;
          height: 12px;
          background: url(./images/bf-splite.png) top left / 100% 100% no-repeat;
          transform: rotateY(180deg);
        }
      }
      .rec-fir-deliver-text {
        margin: 0 3px;
      }
    }

    .rec-coins {
      width: 100%;
      height: 106px;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      position: relative;

      .rec-coins-left {
        min-width: 130px;
        max-width: 150px;
        min-height: 74px;
        border-radius: 8px;
        background: #fffff4;
        .rec-coins-tit {
          padding: 4px 12px;
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
          background: #f6e6c6;
          display: flex;
          align-items: center;

          color: #844920;
          font-family: 'Inter-Tight';
          font-size: 12px;
          font-weight: bold;
          line-height: 14px;
        }
        .rec-coins-num {
          display: flex;
          align-items: center;
          justify-content: center;

          color: #d87835;
          text-align: center;
          font-family: 'TikTokSans-Regular';
          font-size: 24px;
          font-style: italic;
          font-weight: bold;
          line-height: 28px;
          padding: 8px 0;

          img {
            width: 32px;
            height: 32px;
            margin: 0 3px;
          }
        }
      }
      .rec-coins-center {
        width: 19px;
        height: 100%;
        position: relative;
        overflow: visible;
        .up-img {
          width: 40px;
          height: 40px;
          background: url(./images/bf-up.png) top left / 100% auto no-repeat;
          position: absolute;
          left: 50%;
          bottom: 13px;
          margin-left: -20px;
        }
      }
      .rec-coins-right {
        min-width: 130px;
        max-width: 150px;
        min-height: 86px;
        border-radius: 8px;
        background: #fffff4;
        .rec-coins-tit {
          padding: 4px 12px;
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
          background: linear-gradient(90deg, #ecc388 0%, #bd7d23 100%);
          display: flex;
          align-items: center;

          color: #ffffff;
          font-family: 'Inter-Tight';
          font-size: 12px;
          font-weight: bold;
          line-height: 14px;
        }
        .rec-coins-num {
          display: flex;
          align-items: center;
          justify-content: center;

          color: #c1270d;
          text-align: center;
          font-family: 'TikTokSans-Regular';
          font-size: 24px;
          font-style: italic;
          font-weight: bold;
          line-height: 28px;
          padding: 8px 0;

          img {
            width: 48px;
            height: 48px;
            margin: 0 3px;
          }
        }
      }

      .rec-coins-discount {
        position: absolute;
        top: -18px;
        right: 10px;

        width: 66px;
        height: 66px;
        display: flex;
        align-items: center;
        justify-content: center;

        background: url(./images/bf-redsun.png) top left / 100% 100% no-repeat;
        color: var(--System-Color-White-All, #fff);
        font-family: 'Inter-Tight';
        font-size: 18px;
        font-style: italic;
        font-weight: bold;
        line-height: 32px;

        .plus {
          color: var(--System-Color-White-All, #fff);
          text-align: center;
          font-family: 'Inter-Tight';
          font-size: 15px;
          font-style: italic;
          font-weight: 600;
          line-height: 32px;
        }
      }
    }

    .rec-coins-btn {
      width: 311px;
      height: 52px;
      margin: 20px auto 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: url(./images/bf-btn-on.png) top left / 100% 100% no-repeat;
      color: #fbeed1;
      font-family: 'TikTokSans-Regular';
      font-size: 24px;
      font-weight: bold;
      line-height: 26px;

      img {
        display: block;
        width: 24px;
      }
      > div {
        display: flex;
        align-items: flex-end;
        i {
          color: #fbeed1;
          font-family: 'Inter-Tight';
          font-size: 12px;
          font-style: normal;
          font-weight: bold;
          line-height: 14px;
          margin-bottom: 2px;
        }
        span {
          margin: 0 4px;
        }
      }
    }

    .rec-coins-btn.disable {
      background: url(./images/bf-btn-off.png) top left / 100% 100% no-repeat;
      color: #bebdbc;
      img {
        filter: grayscale(1);
      }
      > div {
        i {
          color: #bebdbc;
        }
      }
    }

    .rec-coins-tips {
      margin: 12px auto 0;
      color: rgba(255, 255, 255, 0.7);
      text-align: center;
      font-family: 'TikTokSans-Regular';
      font-size: 15px;
      line-height: 20px;
      &.in-pan {
        color: #ffffff;
      }
    }

    .wheel-pan-block {
      .wheel-pan {
        width: 291px;
        height: 291px;
        margin: 24px auto;
        display: flex;
        align-items: center;
        justify-content: center;
        background: url(./images/wheel-pan.png) top left / 100% auto no-repeat;
        position: relative;

        .wheel-pointer {
          position: absolute;
          top: 50%;
          left: 50%;
          z-index: 99;
          margin-top: -30px;
          margin-left: -20px;
          width: 40px;
          height: 52px;
          background: url(./images/wheel-pointer.png) center top / 100% auto no-repeat;
        }
      }

      .wheel-base {
        width: 303px;
        height: 106px;
        margin: -52px auto 0;
        background: url(./images/bf-base.png) left top / 100% 100% no-repeat;
      }

      .wheel-tips {
        width: 100%;
        line-height: 52px;
        margin-top: -50px;
        margin-bottom: 34px;
        background: url(./images/wheel-tips.png) center center / 175px 52px no-repeat;

        color: rgba(255, 255, 255, 0.7);
        text-align: center;
        font-family: 'TikTokSans-Regular';
        font-size: 17px;
        font-weight: bold;
        i {
          color: #fff;
          font-family: 'TikTokSans-Regular';
          font-size: 22px;
          font-style: italic;
          font-weight: bold;
        }
      }
    }
  }

  .act-con-coins {
    margin: -90px auto 0;
    border-radius: 8px;
    border: 1px solid #f2d99d;
    background: linear-gradient(341deg, rgba(32, 26, 21, 0.4) 0%, rgba(58, 43, 15, 0.4) 100%);
    backdrop-filter: blur(6px);
  }

  .act-con-pan {
    margin-top: 20px;
  }

  .act-tips {
    width: 343px;
    margin: 40px auto;
    .act-tips-tit {
      color: rgba(255, 255, 255, 0.9);
      font-family: 'TikTokSans-Regular';
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 12px;
    }
    .act-tips-con {
      color: rgba(255, 255, 255, 0.7);
      font-family: 'TikTokSans-Regular';
      font-size: 12px;
      font-weight: 400;
      display: flex;
      align-items: flex-start;
      line-height: 16px;
      margin-bottom: 3px;
    }
  }

  .mask {
    width: 100%;
    height: 100%;
    background: var(--mask-black-75, rgba(0, 0, 0, 0.75));

    position: fixed;
    left: 0;
    top: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    .dialog {
      width: 343px;
      margin-top: -24px;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;

      .dia-tit {
        width: 100%;
        background: url(./images/bf-dia-star.png) center center / 227px 98px no-repeat;
        padding-top: 24px;
        p {
          display: flex;
          align-items: center;
          justify-content: center;
          &:nth-child(1) {
            font-family: 'TikTokSans-Regular';
            font-size: 36px;
            font-style: normal;
            font-weight: 900;
            line-height: 36px;
            background: linear-gradient(186deg, #ffe2b5 28.49%, #ebbe5c 75.72%);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          &:nth-child(2) {
            font-family: 'TikTokSans-Regular';
            font-size: 24px;
            font-style: normal;
            font-weight: 900;
            line-height: 36px;
            background: linear-gradient(186deg, #ffe2b5 28.49%, #ebbe5c 75.72%);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
      }

      .dia-con {
        width: 100%;
        min-height: 120px;
        margin-top: 12px;
        background: url(./images/bf-dia-bg.png) left top / 100% 100% no-repeat;
        display: flex;
        align-items: center;
        justify-content: center;
        .gift-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .gift-icon {
            width: 64px;
            height: 64px;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 40px;
              height: 40px;
            }
          }
          .gift-num {
            color: #fbeed1;
            text-align: center;
            font-family: 'TikTokSans-Regular';
            font-size: 16px;
            font-style: italic;
            font-weight: bold;
            line-height: 20px;
            margin-top: 4px;
          }
        }
        .gift-gap {
          width: 24px;
        }
      }

      .dia-btn {
        min-width: 116px;
        height: 52px;
        margin-top: 24px;
        border-radius: 100px;
        border: 2px solid #f9eecf;
        background: linear-gradient(92deg, #292721 0%, #221913 100%);

        display: flex;
        align-items: center;
        justify-content: center;

        color: #fbeed1;
        font-family: 'TikTokSans-Regular';
        font-size: 24px;
        font-weight: 600;
      }
    }
  }
}

.outher {
  width: 245px;
  height: 245px;
  position: relative;
  border-radius: 50%;
  overflow: hidden;

  .wapper {
    width: 246px;
    height: 246px;
    border-radius: 50%;
    background: url(./images/wheel-loop.png) left top / 100% 100% no-repeat;
    .part1 {
      position: absolute;
      width: 123px;
      height: 246px;
      right: 0;
      overflow: hidden;
      text-align: center;

      .text {
        position: absolute;
        transform: rotate(22.5deg);
        text-align: center;

        .pan-txt-item {
          color: #cd2411;
          text-align: center;
          font-family: 'Inter-Tight';
          font-size: 12px;
          font-weight: 700;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 3px;
          img {
            width: 24px;
            height: 24px;
            margin: 0 4px;
          }
        }

        .pan-num-item {
          .discount {
            color: #cd2411;
            text-align: center;
            font-family: 'Inter-Tight';
            font-size: 16px;
            font-weight: bold;
          }
          img {
            width: 40px;
            height: 40px;
          }
        }
      }

      .item {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transform-origin: left center;
      }

      .item.one {
        transform: rotate(0deg);
        z-index: 1;
        .text {
          top: 14px;
          left: 7%;
        }
      }

      .item.two {
        transform: rotate(45deg);
        z-index: 2;
        .text {
          top: 14px;
          left: 7%;
        }
      }

      .item.three {
        transform: rotate(90deg);
        z-index: 3;
        .text {
          top: 14px;
          left: 7%;
        }
      }

      .item.four {
        transform: rotate(135deg);
        z-index: 4;
        .text {
          top: 14px;
          left: 7%;
        }
      }
    }

    .part2 {
      position: absolute;
      width: 123px;
      height: 246px;
      left: 0;
      overflow: hidden;

      .text {
        position: absolute;
        transform: rotate(-22.5deg);
        text-align: center;

        .pan-txt-item {
          color: #cd2411;
          text-align: center;
          font-family: 'Inter-Tight';
          font-size: 12px;
          font-weight: 700;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 3px;
          img {
            width: 24px;
            height: 24px;
            margin: 0 4px;
          }
        }

        .pan-num-item {
          .discount {
            color: #cd2411;
            text-align: center;
            font-family: 'Inter-Tight';
            font-size: 16px;
            font-weight: bold;
          }
          img {
            width: 40px;
            height: 40px;
          }
        }
      }

      .item {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transform-origin: right center;
      }

      .item.five {
        transform: rotateZ(-135deg);
        z-index: 4;
        .text {
          top: 14px;
          left: 52%;
        }
      }

      .item.six {
        transform: rotate(-90deg);
        z-index: 3;
        .text {
          top: 14px;
          left: 55%;
        }
      }

      .item.seven {
        transform: rotate(-45deg);
        z-index: 2;
        .text {
          top: 14px;
          left: 52%;
        }
      }

      .item.eight {
        transform: rotate(0deg);
        z-index: 1;
        .text {
          top: 14px;
          left: 55%;
        }
      }
    }

    .part1 {
      .got {
        background: url(./images/selected-part1.png) left top / 100% 100% no-repeat !important;
        .text {
          .pan-txt-item {
            color: #fbeed1 !important;
          }
          .discount {
            color: #fbeed1 !important;
          }
        }
      }
    }
    .part2 {
      .got {
        background: url(./images/selected-part2.png) left top / 100% 100% no-repeat !important;
        .text {
          .pan-txt-item {
            color: #fbeed1 !important;
          }
          .discount {
            color: #fbeed1 !important;
          }
        }
      }
    }
  }

  .text {
    font-size: 0;
    .discount {
      color: #f74100;
      text-align: center;
      font-family: 'Inter-Tight';
      font-size: 24px;
      font-weight: 700;
      line-height: 26px;
    }

    .txt {
      color: #f74100;
      font-family: 'Inter-Tight';
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .act-root .act-con .rec-coins .rec-coins-discount {
    right: unset;
    left: 10px;
  }
  .act-root .act-con .rec-coins .rec-coins-center .up-img {
    transform: rotateY(180deg);
  }
}
</style>
